/* _customled-list-collections.js — Custom LED owned
 *
 * Appends a "Shop All Products" CTA tile as the LAST item in the /collections
 * (list-collections) grid. The list page only shows hand-picked collections; this
 * tile is the catch-all into the full catalog at /collections/all, where the
 * make/model fitment filters let shoppers narrow the whole store to their bike.
 * Mirrors the PRODUCTS mega-menu "Shop All Products" link.
 *
 * Styling matches the "Find My Relay" card injected into collection grids
 * (_customled-find-my-relay-card.*): a brand-navy panel filling the grid cell with
 * an eyebrow / title / text / theme-button, so the two injected CTAs read as a
 * consistent family. See _customled-list-collections.css.
 *
 * Owned, zero vendor edits. Loaded + gated to the list-collections template by
 * snippets/_customled-stylesheets.liquid, which also sets window.CUSTOMLED_ALL_URL
 * to the locale-correct /collections/all URL (Markets-safe). Idempotent.
 */
(function () {
  if (!document.body.classList.contains('template-list-collections')) return;
  var ALL_URL = window.CUSTOMLED_ALL_URL || '/collections/all';

  function buildTile() {
    // M1.21: strings come from the loader (locale keys via window.CUSTOMLED_LC_STRINGS)
    // so the tile renders localized on /es and /fr; EN literals are the fallback.
    // dec(): Shopify's t-filter HTML-escapes non-_html keys — decode entities
    // via detached textarea (inert) so apostrophes render as characters.
    function dec(s) {
      if (!s || s.indexOf('&') === -1) return s;
      var t = document.createElement('textarea');
      t.innerHTML = s;
      return t.value;
    }
    var R = window.CUSTOMLED_LC_STRINGS || {};
    var S = { eyebrow: dec(R.eyebrow), title: dec(R.title), text: dec(R.text) };
    var item = document.createElement('div');
    item.className = 'grid-item customled-shop-all-li';
    item.setAttribute('data-customled-shop-all', '');
    var card = document.createElement('div');
    card.className = 'customled-shop-all-card';
    function span(cls, text) {
      var el = document.createElement('span');
      el.className = cls;
      el.textContent = text;
      return el;
    }
    card.appendChild(span('customled-shop-all-eyebrow', S.eyebrow || 'Browse everything'));
    card.appendChild(span('customled-shop-all-title', S.title || 'Shop All Products'));
    card.appendChild(span('customled-shop-all-text', S.text || 'See our full catalog and filter by your motorcycle to find your exact fit.'));
    var a = document.createElement('a');
    a.className = 'button customled-shop-all-btn';
    a.href = ALL_URL;
    a.textContent = S.title || 'Shop All Products';
    card.appendChild(a);
    item.appendChild(card);
    return item;
  }

  function inject() {
    var grid = document.querySelector('.section-main-list-collections .collection-list.grid');
    if (!grid) return;
    if (grid.querySelector('[data-customled-shop-all]')) return;
    grid.appendChild(buildTile());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject);
  else inject();
})();
